<template>
    <ul class="list-unstyled vue-dropdown-root" :data-id="_uid" :class="{'vue-dropdown-enabled': enabled}">
        <li class="vue-dropdown">
            <span @click.prevent="toggle" class="vue-dropdown-trigger">
                <i class="fa fa-navicon"></i>
            </span>
            <ul :class="`vue-dropdown-menu vue-dropdown-position-${position==='right'?'right':'left'}`" :style="{visibility:enabled ? 'visible':'hidden'}">
                <slot></slot>
            </ul>
        </li>
    </ul>
</template>

<script>
    export default {
        props: {
          disabled: {
            type: Boolean,
            default: false
          },
          position: {
            type: String,
            default: 'right'
          }
        },
        data() {
            return {
                enabled: false,
            };
        },
        methods: {
            closest(el, className) {
                while (el.parentNode) {
                    el = el.parentNode;
                    if (el.classList.contains(className))
                        return el;
                }
                return null;
            },
            open() {
                this.enabled = true;
                const vm = this;

                setTimeout(() => {
                    vm.$el.addEventListener('click', this.handleClick);
                    document.body.addEventListener('click', this.close, false);
                }, 250);
            },

            handleClick(e) {
                if (e.target.classList.contains('disabled')) {
                    e.stopPropagation();
                    return;
                }
                const parent = this.closest(e.target, 'vue-dropdown-root');

                if (parent !== null && parent.dataset.id == this._uid) {
                    this.close();
                    e.stopPropagation();
                }
            },
            close() {
                this.enabled = false;
                this.$el.removeEventListener('click', this.handleClick);
                document.body.removeEventListener('click', this.close, false);
            },

            toggle() {
                if (this.disabled) {
                  return;
                }
                this.enabled ? this.close() : this.open();
            },
        },
        created() {
          this.planDragStartedHandler = (() => {
            if (this.enabled) {
              this.close();
            }
          });
          this.$root.$on('plan-drag-started', this.planDragStartedHandler);
        },
        beforeDestroy() {
          this.$root.$off('plan-drag-started', this.planDragStartedHandler);
        },
    };
</script>

<style type="text/scss" lang="scss">
    .vue-dropdown-trigger {
        color: #b8b0b7;
        display: block;
        border-radius: 3px;
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        position: relative;
        z-index: 1;
        &:hover {
            color: #fff;
        }
    }

    .vue-dropdown-enabled {
        z-index: 1001;
        .vue-dropdown-trigger {
            color: #fff;
        }
    }

    .vue-dropdown-menu {
        position: absolute;
        top: 100%;
        left: 0;
        z-index: 101;
        float: left;
        min-width: 160px;
        padding: 5px 0;
        margin: 2px 0 0;
        font-size: 14px;
        text-align: left;
        list-style: none;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        box-shadow: 0 6px 12px rgba(0, 0, 0, .175);

        li a:hover {
            background-color: #e1e3e9;
            color: #333;
        }

        li a.disabled {
            background-color: #e1e3e9;
        }

        li a.disabled:hover {
            cursor: default;
            color: #777
        }

        > li > a {
            display: block;
            padding: 3px 20px;
            clear: both;
            font-weight: 400;
            line-height: 1.42857143;
            white-space: nowrap;
            color: #777;
        }

        li.divider {
            display: block;
            height: 1px;
            margin: 9px 0;
            overflow: hidden;
            background-color: #e5e5e5;
        }

        li > a > .glyphicon,
        li > a > .fa,
        li > a > .ion {
            margin-right: 10px;
        }

    }

    .vue-dropdown-position-right {
        right: 0;
        left: auto;
    }
    .vue-dropdown-position-left {
        left: 0;
        right: auto;
    }
</style>
